import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=90fca5b0&scoped=true"
import script from "./confirmDialog.vue?vue&type=script&lang=js"
export * from "./confirmDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=90fca5b0&prod&lang=scss&scoped=true"
import style1 from "./confirmDialog.vue?vue&type=style&index=1&id=90fca5b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fca5b0",
  null
  
)

export default component.exports